import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { asyncGetUser } from '../../../services/users.service';
import Loading from '../../components/general/loadings/loading';
import UserForm from './form';
import { SurveyList } from '../../../shared/types/survey.interface';
import { asyncGetProjects } from '../../../services/project.service';
import {
    BodyProject,
    ProjectInterface,
} from '../../../shared/types/project.interface';

const EditUser = () => {
    const { idUser } = useParams();
    const [row, setRow] = useState<any>();
    const [loading, setLoading] = useState<boolean>(true);
    const [onSave, setOnSave] = useState<boolean>(false);
    const [projects, setProjects] = useState<SurveyList[]>([]);

    useEffect(() => {
        asyncGetUser(idUser).then((bodyuser: any) => {
            if (bodyuser.items !== undefined) {
                const user = bodyuser.items;
                asyncGetProjects().then((body: BodyProject) => {
                    if (body.items !== undefined) {
                        if (user.projectIds != null) {
                            const valuesformuser = user.projectIds.map(
                                (item: ProjectInterface) => ({
                                    id: item.id,
                                    name: item.nameProject,
                                })
                            );
                            bodyuser.items.projectIds = valuesformuser;
                        } else {
                            bodyuser.items.projectIds = [];
                        }
                        setProjects(
                            body.items.items.map((item) => ({
                                id: item.id,
                                name: item.nameProject,
                            }))
                        );
                        setRow(bodyuser.items);
                        setLoading(false);
                    }
                });
            }
        });
    }, [idUser, onSave]);

    return loading ? (
        <Loading />
    ) : (
        <UserForm
            idUser={idUser}
            user={row}
            projects={projects}
            onSave={(value: any) => setOnSave(value)}
        />
    );
};

export default EditUser;
